export default defineNuxtRouteMiddleware(async (to, from) => {
    const shoppingCardInfo = useShoppingCardInfo()

    const {get} = useOFetchCustom(`shopping-card-info`)

    try{
        await new Promise((resolve, reject)=>{
            get(undefined, {
                onSuccess: (response:any) => {
                    shoppingCardInfo.value = response.data
                    resolve(response)
                },
                onError: (error:any) => {
                    reject(error)
                }
            })
        })
    }catch(error:any){
        return navigateTo("/store")
    }
})